import styled from 'styled-components'

import { helpers, toRem } from 'styles'

export const IconWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: ${toRem(40)};
	height: ${toRem(40)};
	color: ${helpers.color.iconContent};
	background-color: ${helpers.color.iconBackground};
	border-radius: 50%;
	flex-shrink: 0;
`
